module.exports = __webpack_public_path__ + "static/img/main.ffbb502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/5/main.png
// module id = 6Icu
// module chunks = 1